import React, { useState } from "react";

import GoBack from "../../../../components/go-back";
import Table from "../../../../components/table-simple/table";
import Pagination from "../../../../components/pagination";
import LeftInfoModal from "../../../../components/left-info-modal";
import NoData from "../no-data";
import SelectBox from "../../../../components/select-box/select-box";
import LoaderSpinner from "../../../../components/loader-spinner";
import { RequestsContainer, SectionContainer } from "./requests-style";
import { images } from "../../../../assets";

import useGetRequests from "./useGetRequests";
import DebtRecoveryServices from "../../../../services/DebtRecoveryServices";
import { MODAL_SEND_DEBT_EMAIL_KO, MODAL_SEND_DEBT_EMAIL_OK } from "../helpers";
import { isValidEmail } from "../../../../utils/validation";
import { getRelatedMediatorsCodes } from "../../../../utils/mediatorCode";
import { LeftInfoModalProps } from "../../../../components/left-info-modal/left-info-modal-layout";
import { EmailModal, UserEmail } from "../debt-recovery-types";
import { RequestsProps, RowData } from "./requests-types";
import { MediatorCodesInputType } from "../../clients-dashboard/clients-dashboard-types";
import { ReGeneratePaymentRequest } from "../../../../services/DebtRecoveryServices.dto";

const PendingRequests = ({ mediator, setLoading }: RequestsProps) => {
  const emptyUserEmail: UserEmail = {
    value: "",
    errorCode: "",
  };
  const [emailModal, setEmailModal] = useState<EmailModal>({ showModal: false, debtItem: "" });
  const [userEmail, setUserEmail] = useState<UserEmail>(emptyUserEmail);
  const [responseModal, setResponseModal] = useState<Partial<LeftInfoModalProps> | null>(null);
  const [mediatorCode, setMediatorCode] = useState<string>(mediator.mediatorCode);
  const [requestData, setRequestData] = useState<ReGeneratePaymentRequest>({
    takerNif: "",
    birthDate: "",
    codRamo: "",
    codSubramo: "",
    requestId: "",
    email: "",
    mediatorCode: "",
  });

  const mediatorCodesInput: MediatorCodesInputType = {
    codeOptions: getRelatedMediatorsCodes(mediator),
    selectedCode: mediatorCode,
  };

  const handleOnClickOneDebt = (row: RowData) => {
    setRequestData({
      takerNif: row.takerNif,
      birthDate: row.birthDate,
      requestId: row.requestId,
      codRamo: row.codRamo || "",
      codSubramo: row.codSubramo || "",
      mediatorCode,
      email: "",
    });
    setEmailModal({ showModal: true, debtItem: row.requestId });
  };

  const { pagination, setPagination, isLoading, data, error, setRefresh } = useGetRequests({
    mediatorCode,
    isPending: true,
    handleOnClickOneDebt,
  });

  const handleSendEmail = async () => {
    if (!isValidEmail(userEmail.value)) {
      setUserEmail((prevUserEmail) => ({ ...prevUserEmail, errorCode: "invalid-email" }));
      return;
    }

    setEmailModal({ showModal: false, debtItem: "" });

    const request = {
      ...requestData,
      email: userEmail.value,
    };

    const response = await DebtRecoveryServices.reGeneratePaymentRequest({
      loader: true,
      setLoading,
      request,
    });

    if (response.ok) {
      setResponseModal(MODAL_SEND_DEBT_EMAIL_OK);
      setRefresh(true);
    } else {
      const modalContent = {
        ...MODAL_SEND_DEBT_EMAIL_KO,
        mainText: response.message || MODAL_SEND_DEBT_EMAIL_KO.mainText,
      };
      setResponseModal(modalContent);
    }
    setUserEmail(emptyUserEmail);
  };

  return (
    <RequestsContainer>
      <div className="black-arrow-container">
        <GoBack text="Volver" />
      </div>

      <div className="main-title-container">
        <h2>SOLICITUDES PENDIENTES</h2>
      </div>

      <SectionContainer>
        {mediatorCodesInput.codeOptions.length > 1 ? (
          <div className="mediators">
            <div className="selectBox">
              <SelectBox
                isMediator
                optionsText={mediatorCodesInput.codeOptions}
                optionKey="value"
                optionValue="label"
                defaultValue={mediatorCode}
                initialValue={mediatorCodesInput.selectedCode}
                propValue={mediatorCodesInput.selectedCode}
                disabled={mediatorCodesInput.codeOptions.length < 2}
                required
                onChange={(value: string) => setMediatorCode(value)}
              />
              <label>Mediador</label>
            </div>
          </div>
        ) : null}
        {isLoading && (
          <div className="spinner">
            <LoaderSpinner />
          </div>
        )}
        {!isLoading && data && (
          <>
            <Table
              columns={data.columns}
              data={data.data}
              actions={data.actions}
              actionsColumnName={data.actionsColumnName}
            />
            <div className="requests-pagination">
              <Pagination
                page={pagination.page}
                limit={pagination.totalPages}
                callback={(newPage: number) =>
                  setPagination((prevPagination) => ({ ...prevPagination, page: newPage }))
                }
              />
            </div>
          </>
        )}
        {error && <NoData message={error} />}
      </SectionContainer>

      <LeftInfoModal
        img={images.IconContactCollapsedWhite}
        mainTitle="Envío de petición de recobro"
        mainText={`Por favor, ingrese un email para el envío de la petición de recobro del recibo ${emailModal.debtItem}`}
        buttonText="Enviar"
        close={() => setEmailModal((prevEmailModal) => ({ ...prevEmailModal, showModal: false }))}
        active={emailModal.showModal}
        onClickAccept={handleSendEmail}
        withInput={{
          labelText: "email",
          value: userEmail.value,
          errorCode: userEmail.errorCode,
          onChange: (value: string) => setUserEmail({ value, errorCode: "" }),
        }}
      />

      {responseModal && (
        <LeftInfoModal
          active={responseModal.active}
          img={responseModal.img}
          mainTitle={responseModal.mainTitle}
          mainText={responseModal.mainText}
          close={() => setResponseModal(null)}
          closeButtonText="Cerrar"
          noMainButton
          centerPrimaryButton
        />
      )}
    </RequestsContainer>
  );
};

export default PendingRequests;
